var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoProga(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 546,
    height: 86,
    viewBox: "0 0 546 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.74 13.41C185.2 9.53 181.62 6.52999 176.93 4.41999C172.27 2.28999 166.75 1.23999 160.41 1.23999H114.23V14.75H148.45H159.49C164.46 14.75 168.25 15.83 170.84 17.98C173.43 20.13 174.72 23.21 174.72 27.24C174.72 31.18 173.43 34.24 170.84 36.39C168.25 38.54 164.46 39.6 159.49 39.6H145.98H129.42V72.86H145.98V53.12H160.41C166.75 53.12 172.27 52.07 176.93 50C181.61 47.91 185.2 44.91 187.74 40.99C190.26 37.07 191.52 32.49 191.52 27.24C191.52 21.92 190.26 17.31 187.74 13.41Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M258.33 49.85C263.03 47.8 266.66 44.86 269.23 41C271.79 37.16 273.05 32.55 273.05 27.25C273.05 21.93 271.8 17.32 269.27 13.42C266.75 9.54 263.15 6.54 258.48 4.43C253.8 2.3 248.3 1.25 241.96 1.25H210.95V14.75H230.47V14.77H241.02C246.01 14.77 249.8 15.84 252.39 17.99C254.98 20.14 256.27 23.22 256.27 27.25C256.27 31.19 254.98 34.27 252.39 36.46C249.8 38.64 246.01 39.66 241.02 39.66H227.52H210.94V72.86H227.52V52.91H242.77L256.59 72.86H274.38L258.33 49.85Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M362.58 18.07C359.17 12.45 354.51 8.03001 348.56 4.83001C342.63 1.61001 335.94 0.0100098 328.51 0.0100098C321.08 0.0100098 314.37 1.61001 308.42 4.83001C302.43 8.03001 297.77 12.46 294.4 18.07C291.03 23.71 289.33 30.03 289.33 37.05C289.33 44.07 291.03 50.41 294.4 56.03C297.77 61.67 302.44 66.07 308.42 69.27C314.37 72.49 321.08 74.09 328.51 74.09C335.94 74.09 342.63 72.49 348.56 69.27C354.51 66.07 359.17 61.66 362.58 56.03C365.99 50.41 367.69 44.07 367.69 37.05C367.69 30.03 365.99 23.71 362.58 18.07ZM348.01 48.93C346.06 52.4 343.39 55.11 339.97 57.06C336.56 58.99 332.73 59.97 328.5 59.97C324.27 59.97 320.46 58.99 317.05 57.06C313.64 55.11 310.96 52.4 309.01 48.93C307.06 45.44 306.1 41.48 306.1 37.05C306.1 32.62 307.06 28.66 309.01 25.19C310.96 21.7 313.63 18.99 317.05 17.06C320.46 15.11 324.27 14.13 328.5 14.13C332.73 14.13 336.56 15.11 339.97 17.06C343.38 18.99 346.06 21.7 348.01 25.19C349.94 28.66 350.92 32.62 350.92 37.05C350.91 41.48 349.94 45.44 348.01 48.93Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M436.24 56.91C432.42 58.96 428.13 59.97 423.35 59.97C418.84 59.97 414.85 58.99 411.32 57.06C407.81 55.11 405.08 52.4 403.09 48.93C401.12 45.44 400.13 41.48 400.13 37.05C400.13 32.54 401.12 28.57 403.09 25.07C405.08 21.6 407.83 18.91 411.38 17C414.93 15.09 418.99 14.13 423.55 14.13C430.79 14.13 436.95 16.82 442.08 22.2L452.71 12.39C449.24 8.37 444.95 5.29 439.82 3.18C434.71 1.05 429.01 0 422.73 0C415.24 0 408.47 1.6 402.48 4.76C396.47 7.94 391.79 12.33 388.4 17.96C385.03 23.58 383.35 29.94 383.35 37.03C383.35 44.13 385.03 50.49 388.4 56.11C391.79 61.75 396.44 66.14 402.36 69.31C408.31 72.49 414.98 74.07 422.43 74.07C427.6 74.07 432.75 73.29 437.88 71.71C442.99 70.15 447.5 67.91 451.38 64.96V42.2H436.24V56.91Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M513.28 1.23999H496.9L464.99 72.86H481.98L487.09 60.47H487.03L495.75 39.72H495.79L505 17.5L516.35 44.92H516.33L521.54 57.5H521.58L527.92 72.85H545.3L513.28 1.23999Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.56 1.32001H0V15.61H78.56V1.32001Z",
    fill: "url(#paint0_linear_135_24)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.34 24.75H0V39.04H95.34V24.75Z",
    fill: "url(#paint1_linear_135_24)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.06 48.17H0V62.46H79.06V48.17Z",
    fill: "url(#paint2_linear_135_24)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.51 71.6H0V85.89H38.51V71.6Z",
    fill: "url(#paint3_linear_135_24)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_135_24",
    x1: -32.0987,
    y1: 8.46731,
    x2: 77.3177,
    y2: 8.46731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58398E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9661,
    stopColor: "#B267A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_135_24",
    x1: -32.0987,
    y1: 31.8923,
    x2: 77.3177,
    y2: 31.8923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58398E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9661,
    stopColor: "#B267A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_135_24",
    x1: -32.0987,
    y1: 55.3172,
    x2: 77.3177,
    y2: 55.3172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58398E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9661,
    stopColor: "#B267A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_135_24",
    x1: -32.0987,
    y1: 78.7421,
    x2: 77.3177,
    y2: 78.7421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58398E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9661,
    stopColor: "#B267A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoProga);
export default __webpack_public_path__ + "static/media/Logo-proga.bfc234e25d5521d30d8765e090f1a9b9.svg";
export { ForwardRef as ReactComponent };